import Button from 'components/UI/Button';
import { useModal } from 'hooks';
import {
    AUTH_MODAL,
} from '_constants/modalTypes';

import StyledConnection from './styles';

const Connection = ({ t, welcomeText, connectionWarning }) => {
    const {
        onOpen: onModalOpen,
    } = useModal();
    const openAuthModal = () => onModalOpen(AUTH_MODAL);

    return (
        <StyledConnection>
            <p>
                {welcomeText}
                {' '}
                This page will be used to gather some preliminary information from you, which will later be used at various
                steps during the whole process. Please connect your Ethereum wallet to continue (e.g. MetaMask, Wallet Connect).
                You cannot use a centralized and/or exchange wallet. Make sure that you have completed your KYC/AML verification on
                {' '}
                <a
                    target="_blank"
                    href="https://www.fasttoken.com/"
                    rel="noreferrer">
                    Fastex.com.
                </a>
            </p>
            <b>
                {connectionWarning || 'NOTE: This wallet will also be used to claim your FTN tokens in the future.'}
            </b>
            <Button onClick={openAuthModal}>{t('connectWalletButton')}</Button>
            <p>
                If you do not have an Ethereum Wallet, we recommend MetaMask, one of the best decentralized Ethereum wallets in the world. For your convenience,
                guides on how to download and setup MetaMask are here (
                <a
                    target="_blank"
                    href="https://docs.fasttoken.com/MetaMask-Setup-How-to-Guide(desktop).pdf"
                    rel="noreferrer">
                    MetaMask desktop
                </a>
                ), (
                <a
                    target="_blank"
                    href="https://docs.fasttoken.com/MetaMask-Setup-How-to-Guide(mobile).pdf"
                    rel="noreferrer">
                    MetaMask mobile
                </a>
                ).
            </p>
        </StyledConnection>
    );
};

export default Connection;
